// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileAddOutlinedSvg from "@ant-design/icons-svg/es/asn/FileAddOutlined";
import AntdIcon from '../components/AntdIcon';

var FileAddOutlined = function FileAddOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileAddOutlinedSvg
  }));
};

FileAddOutlined.displayName = 'FileAddOutlined';
export default React.forwardRef(FileAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileAddOutlined.js
// module id = 1087
// module chunks = 0